import { render } from "./AddressBookInfo.vue?vue&type=template&id=6f6e3cc4&scoped=true"
import script from "./AddressBookInfo.vue?vue&type=script&lang=js"
export * from "./AddressBookInfo.vue?vue&type=script&lang=js"

import "./AddressBookInfo.vue?vue&type=style&index=0&id=6f6e3cc4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6e3cc4"]])

export default __exports__